class DropdownDetails extends HTMLElement {
  constructor() {
    super()
    this.$details = this.querySelector('details')
    this.$trigger = this.querySelector('summary')
    this.$triggerText = this.$trigger.querySelector('.details__label')
    this.$content = this.querySelector('.details--dropdown__content')
    this.$actions = this.querySelectorAll('.js-dropdown')
  }

  connectedCallback() {
    this.$trigger.addEventListener('click', this._handleClick.bind(this))

    this.$actions.forEach(($action) => {
      $action.addEventListener('click', this._handleSwitch.bind(this))
    })
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target == this.$details) {
      this.close(false)
    }
  }

  open() {
    this.$details.open = true
    slideDown(this.$content)
    if (this.classList.contains('close-click-outside')) {
      this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this)
      document.body.addEventListener('click', this.onBodyClickEvent)
    }
  }

  close() {
    slideUp(this.$content)
    setTimeout(() => {
      this.$details.open = false
      document.body.removeEventListener('click', this.onBodyClickEvent)
    }, 300)
  }

  _handleClick(event) {
    event.preventDefault()

    if (this.$details.open) {
      this.close()
    } else {
      this.open()
    }
  }

  _handleSwitch(event) {
    this.$triggerText.innerHTML = event.target.innerHTML
    this.close()
  }
}
customElements.define('dropdown-details', DropdownDetails)
